import configService from './configservice';
import { sbToastr } from 'shipbob_design_system';
import { getAuthService } from '@/auth';

export default class FulfillmentCustomizationService {
  constructor(axiosInstance) {
    this.axiosInstance = axiosInstance;
  }
  downloadPackagingSlipPreview = async (data) => {
    try {
      let response = await this.axiosInstance.request(
        'GET',
        configService.PackingSlipApiUrl + '/api/packingSlip/previewPackingSlip',
        undefined,
        data,
        { 
          headers: {
            'pdf': 'true',
          },
          responseType: 'blob', 
        });
      switch (response.status) {
        case 200:
          return new Blob( [ response.data ], { type: 'application/pdf' } );
        case 401:
          await getAuthService().logout();
          break
        default:
          throw new Error(`Unable to Get Packaging Slip Preview`)
      }
    } catch (error) {
      sbToastr.error(`Unable to Get Packaging Slip Preview`)
    }
  }
}